export const formatPrice = (price, locale = "nl-BE") => {
  if (price == null) {
    const labels = { "nl-BE": "Prijs op aanvraag", "fr-BE": "Prix sur demande", "en-US": "Price on request" };
    return labels[locale] || labels["nl-BE"];
  }
  return new Intl.NumberFormat(locale, { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(price);
};

export const formatKm = (km) => {
  return new Intl.NumberFormat("en-US").format(km) + " KM";
};

export const localeFor = (lang) => ({ nl: "nl-BE", fr: "fr-BE", en: "en-US" }[lang] || "nl-BE");
